<template>
  <div class="lixibao-page common-bg">
    <div class="header-section">
      <div class="deposit-row">
        <div class="deposit-title">已存入</div>
        <div class="deposit-amount">{{ depositAmount }}</div>
        <div class="rate-badge">年利率88%</div>
      </div>
      <div class="btn-group">
        <button class="btn-in" @click="handleTransferIn">转入</button>
        <button class="btn-out" @click="handleTransferOut">转出</button>
      </div>
    </div>

    <div class="period-section">
      <div class="period-left">
        <span class="period-label">结算周期</span>
        <span class="period-value">1小时（<span class="period-label">封顶</span>1周期）</span>
      </div>
      <button class="btn-collect" @click="handleCollect">领取</button>
    </div>

    <div class="pending-section">
      <span class="pending-label">待领取</span>
      <span class="pending-amount">{{ pendingAmount }}</span>
      <span class="pending-hint">（已领取 0.00）<span class="refresh-icon" @click="loadData">↻</span></span>
    </div>

    <div class="tabs-section">
      <div class="tabs-header">
        <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">利息规则</div>
        <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">记录明细</div>
      </div>

      <div class="tabs-content">
        <div v-show="activeTab === 0" class="rules-content">
          <div class="rule-item" v-for="(rule, index) in rules" :key="index">
            <span class="rule-num">{{ index + 1 }}.</span>
            <span class="rule-text">{{ rule }}</span>
          </div>
        </div>

        <div v-show="activeTab === 1" class="record-content">
          <div class="filter-bar">
            <div class="filter-select" @click.stop="showDateDropdown = !showDateDropdown">
              <span>{{ filterDateLabels[filterDate] }}</span>
              <span class="arrow">{{ showDateDropdown ? '▲' : '▼' }}</span>
              <div class="dropdown-menu" v-show="showDateDropdown">
                <div v-for="(label, key) in filterDateLabels" :key="key" 
                     class="dropdown-item" :class="{ active: filterDate === key }"
                     @click="filterDate = key; showDateDropdown = false">
                  {{ label }}
                </div>
              </div>
            </div>
            <div class="filter-select" @click.stop="showTypeDropdown = !showTypeDropdown">
              <span>{{ filterTypeLabels[filterType] }}</span>
              <span class="arrow">{{ showTypeDropdown ? '▲' : '▼' }}</span>
              <div class="dropdown-menu" v-show="showTypeDropdown">
                <div v-for="(label, key) in filterTypeLabels" :key="key" 
                     class="dropdown-item" :class="{ active: filterType === key }"
                     @click="filterType = key; showTypeDropdown = false">
                  {{ label }}
                </div>
              </div>
            </div>
            <div class="total-revenue">累计收益 <span class="revenue-amount">{{ totalRevenue }}</span></div>
          </div>

          <div class="record-header">
            <div class="col-time">时间</div>
            <div class="col-type">类型</div>
            <div class="col-amount">金额</div>
          </div>

          <div class="record-empty" v-if="recordList.length == 0">
            <div class="empty-icon-wrap">
              <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
            </div>
            <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
          </div>

          <div class="record-list" v-else>
            <div class="record-item" v-for="(item, index) in recordList" :key="index">
              <div class="col-time">{{ item.time }}</div>
              <div class="col-type">{{ item.type }}</div>
              <div class="col-amount" :class="item.amountType">{{ item.amount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lixibao",
  data() {
    return {
      depositAmount: "0.00",
      pendingAmount: "0.00000000",
      activeTab: 0,
      filterDate: "today",
      filterType: "all",
      filterDateLabels: { today: '今日', yesterday: '昨日', week: '本周', lastWeek: '上周', month: '本月', lastMonth: '上月', all: '全部' },
      filterTypeLabels: { all: '全部', in: '转入', out: '转出', interest: '领取收益', system_out: '系统转出' },
      showDateDropdown: false,
      showTypeDropdown: false,
      totalRevenue: '0.00',
      recordList: [],
      rules: [
        "收益介绍：存入利息宝的金额，至少满足一个完整周期才能产生利息。若中途提前转出则该周期不计收益。例如：当前结算周期为1小时，则2026-01-01 00:00:01转入的金额，当将在2026-01-01 01:00:01产生利息；当在2026-01-01 00:30:00转入的金额，当前利息的结算周期为上个周期利息；",
        "结算周期：当前利息的结算周期为1小时；",
        "年利率：当前年利率为88%；",
        "计算公式：利息收益=存入金额×年利率/结算周期；",
        "举例说明：于2026-01-01 00:00:01存入10000，年利率为88%，结算周期为1小时，则于2026-01-01 01:00:01获得首次利息收益，计算方式如下：首次利息：10000×88%/365天×24小时×1小时=1.04566；",
        "转入门槛：每次转入金额必须大于等于100（即≥100），转入金额无上限，越多收益越多；",
        "利息封顶：利息封顶最多只能结算1个周期，超出则不再产生利息，记得定期或经常来领取收益，以免错过更多收益；",
        "领取时间：当前为隔天领取，即当天产生的利息，要等到第二天2点后才能领取；",
        "本活动所赠送的利息奖金（利息）需达1倍有效投注才能提现，投注不限有效平台。仅限于所领取的利息需稽核，所转入转出的本金则无需稽核要求。",
        "本活动仅限账号本人进行正常游戏投注，禁止租借账号；无风险投注（对赌、对刷、低赔刷水）、恶意套利。"
      ]
    };
  },
  created() {
  },
  methods: {
    handleTransferIn() {
      this.$parent.showTost(0, '转入功能开发中');
    },
    handleTransferOut() {
      this.$parent.showTost(0, '转出功能开发中');
    },

    handleCollect() {
      let that = this;
      if (parseFloat(that.pendingAmount.replace('¥', '')) <= 0) {
        that.$parent.showTost(0, '暂无待领取金额');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun.post('/api/collectInterest', {}).then(res => {
        that.$parent.showTost(res.code == 200 ? 1 : 0, res.message);
        if (res.code == 200) {
          that.loadData();
        }
        that.$parent.hideLoading();
      }).catch(() => {
        that.$parent.hideLoading();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/common.css';

.lixibao-page {
  min-height: 100vh;
  padding-bottom: 1rem;
  margin-top: 44px;
}

.header-section {
  background: linear-gradient(180deg, #292A2C 0%, #1E1F24 100%);
  padding: 0.3rem 0.35rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .deposit-row {
    display: flex;
    align-items: center;
    gap: 0.1rem;

    .deposit-title {
      font-size: 0.26rem;
      color: #888;
    }

    .deposit-amount {
      font-size: 0.4rem;
      font-weight: bold;
      color: #fff;
    }

    .rate-badge {
      background: linear-gradient(90deg, #3CC82F 0%, #52D63E 100%);
      color: #fff;
      font-size: 0.28rem;
      font-weight: bold;
      padding: 0.06rem 0.18rem;
      border-radius: 0.2rem;
    }
  }

  .btn-group {
    display: flex;
    flex-direction: row;
    gap: 0.12rem;

    .btn-in {
      background: linear-gradient(90deg, #FF9900 0%, #FFB84D 100%);
      color: #fff;
      font-weight: bold;
      border-radius: 0.4rem;
      height: 0.75rem;
      line-height: 0.75rem;
      font-size: 0.3rem;
      padding: 0 0.5rem;
      border: none;
    }

    .btn-out {
      background: transparent;
      color: #888;
      font-weight: bold;
      border-radius: 0.4rem;
      height: 0.75rem;
      line-height: 0.75rem;
      font-size: 0.3rem;
      padding: 0 0.5rem;
      border: 1px solid #444;
    }
  }
}

.period-section {
  background: #1E1F24;
  padding: 0.2rem 0.35rem;
  font-size: 0.22rem;
  color: #888;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .period-left {
      display: flex;
      align-items: center;
      gap: 0.1rem;

      .period-value {
        color: #fff;

        .period-label {
          color: #888;
        }
      }
    }

  .btn-collect {
    background: #444;
    color: #888;
    font-weight: bold;
    border-radius: 0.4rem;
    height: 0.75rem;
    line-height: 0.75rem;
    font-size: 0.3rem;
    padding: 0 0.5rem;
    border: 1px solid #555;
  }
}

.pending-section {
  background: #292A2C;
  margin: 0.15rem;
  border-radius: 0.12rem;
  padding: 0.25rem 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.08rem;

  .pending-label {
    font-size: 0.3rem;
    color: #888;
  }

  .pending-amount {
    font-size: 0.35rem;
    font-weight: bold;
    color: #DFB372;
  }

  .pending-hint {
    font-size: 0.3rem;
    color: #fff;

    .refresh-icon {
      font-size: 0.5rem;
      color: #DFB372;
      cursor: pointer;
      margin-left: 0.05rem;
    }
  }
}

.tabs-section {
  margin: 0 0.15rem;
  background: #292A2C;
  border-radius: 0.12rem;
  overflow: hidden;

  .tabs-header {
    display: flex;
    background: #1E1F24;
    border-bottom: 1px solid #3B3C3D;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 0.25rem 0;
      font-size: 0.36rem;
      color: #888;

      &.active {
        color: #DFB372;
      }
    }
  }

  .tabs-content {
    min-height: 3rem;
    position: relative;
  }

  .rules-content {
    padding: 0.25rem;
    background: #1E1F24;

    .rule-item {
      display: flex;
      margin-bottom: 0.2rem;
      font-size: 0.28rem;
      color: #fff;
      line-height: 1.6;

      .rule-num {
        color: #888;
        font-weight: bold;
        margin-right: 0.08rem;
        flex-shrink: 0;
      }

      .rule-text {
        flex: 1;
        color: #888;
      }
    }
  }

  .record-content {
    background: #1E1F24;
    position: relative;
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.3rem;
    background: #292A2C;
    position: relative;

    .filter-btn {
      display: flex;
      align-items: center;
      gap: 0.05rem;
      font-size: 0.26rem;
      color: #888;
      background: #1E1F24;
      padding: 0.1rem 0.2rem;
      border-radius: 0.08rem;

      .arrow {
        font-size: 0.18rem;
      }
    }

    .total-revenue {
      font-size: 0.26rem;
      color: #888;

      .revenue-amount {
        color: #DFB372;
      }
    }

    .filter-select {
      display: flex;
      align-items: center;
      gap: 0.05rem;
      font-size: 0.26rem;
      color: #888;
      background: #1E1F24;
      padding: 0.1rem 0.3rem;
      border-radius: 0.08rem;
      position: relative;
      min-width: 1.6rem;

      .arrow {
        font-size: 0.18rem;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 1.6rem;
        background: #292A2C;
        border-radius: 0.08rem;
        margin-top: 0.05rem;
        z-index: 100;
        overflow: hidden;
        box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.3);

        .dropdown-item {
          padding: 0.2rem 0.3rem;
          font-size: 0.26rem;
          color: #888;
          text-align: center;
          border-bottom: 1px solid #3B3C3D;

          &.active {
            color: #DFB372;
            background: rgba(223, 179, 114, 0.1);
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  .record-header {
    display: flex;
    padding: 0.25rem 0.3rem;
    background: #292A2C;
    border-bottom: 1px solid #3B3C3D;
    font-size: 0.28rem;
    color: #fff;

    .col-time { flex: 1.5; }
    .col-type { flex: 1; text-align: center; }
    .col-amount { flex: 1; text-align: right; }
  }

  .record-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;

    .empty-icon-wrap {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.4rem;

      .empty-icon {
        width: 2.5rem;
        height: 2.5rem;
        opacity: 0.5;
      }
    }

    .empty-text {
      font-size: 0.28rem;
      color: #666;

      .empty-link {
        color: #DFB372;
      }
    }
  }

  .record-list {
    background: #1E1F24;

    .record-item {
      display: flex;
      padding: 0.2rem;
      border-bottom: 1px solid #3B3C3D;
      font-size: 0.26rem;
      color: #fff;

      .col-time { flex: 1.5; color: #888; }
      .col-type { flex: 1; text-align: center; }
      .col-amount { 
        flex: 1; 
        text-align: right;

        &.income { color: #3CC82F; }
        &.expense { color: #FD5A70; }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/component/lixibao.vue